import './location.css'
import React, { useState } from "react";



import { useAddress } from './AddressContext';

function LocationCardCheckout({ address, selected, onSelect }) {

  const { selectedAddress, setSelectedAddress } = useAddress();

  return (
    <>
      <label className="location-details mt-2 ">
        <div className='d-flex gap-2'>
          <input
            className="form-check-input custom-radio"
            style={{ border: "2px solid black" }}
            type="radio"
            id={`addressSelection-${address._id}`}
            name="addressSelection"
            checked={selectedAddress?._id === address._id}
            onChange={() => {
              // onSelect(address);
              setSelectedAddress(address);
            }}
          />
          <div>
          <div className="d-flex justify-content-between  flex-column ">
            <div className="">
              <h3>{address.fullName}</h3>
              <p>{address.city}</p>
              <p>{address.area}</p>
            </div>
          </div>
          <div className="d-flex  justify-content-between align-items-end">
            <div>
              <p className="type">رقم المنزل:<small> {address.house}</small> </p>
              <p className="desc ">{address.address}</p>
              <p className="phone">{address.mobileNumber}</p>
            </div>
          </div>
          </div>
        </div>
      </label>
    </>
  )
}

export default LocationCardCheckout;
